<template>
  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       width="48" height="48" :fill="color">
    <path
        d="M719.786667 232.96c-221.866667-143.786667-512-91.306667-645.973334 117.333333a452.693333 452.693333 0 0 0 40.106667 532.053334 4.693333 4.693333 0 0 0 6.826667 0 6.4 6.4 0 0 0 0-7.68 302.506667 302.506667 0 0 1 2.986666-344.746667c97.706667-128 291.84-148.48 438.613334-42.666667l-59.306667 85.333334a35.413333 35.413333 0 0 0 29.013333 55.466666h450.986667a34.986667 34.986667 0 0 0 32.853333-48.213333L853.333333 162.133333a35.84 35.84 0 0 0-62.72-7.253333l-58.453333 85.333333-11.093333-7.68z m0 0"
    ></path>
  </svg>
</template>
<script setup>
  defineProps({
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  })
</script>
<style scoped>

</style>